import { React, useState, Fragment, useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
// import { ThemeProvider, StyledEngineProvider, makeStyles } from '@mui/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import TopActions from '../actions/TopActions';
import Toast from '../actions/Toasts';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import apiService from '../../services/apiServices';
import validationSchema from '../../services/validationSchema';
import InputController from '../../controllers/InputController';
import SelectController from '../../controllers/SelectController';
import { yupResolver } from '@hookform/resolvers/yup';
import { TextareaAutosize } from '@mui/material';
import { Switch } from '@mui/material';
import {
  BrowserRouter as Router,
  Route,
  Link,
  useParams,
} from 'react-router-dom';


export default function AddWorkerContract() {
  //const classes = useStyles();
  const alert = { open: false, message: '', variant: '' };
  const [toast, setToast] = useState(alert);
  const [workTypes, setWorkTypes] = useState([{ id: 0, name: "" }]);
  const [departments, setDepartments] = useState([{ id: 0, name: "" }]);
  const [branch, setBranch] = useState([{ id: 0, name: "" }]);
  const [templates, setTemplates] = useState([{ id: 0, name: "" }])
  const {
    register,
    handleSubmit,
    control,
    setValue,
    watch,
    formState: { errors },
  } = useForm();
  const salaryTypes = [{ id: 0, name: "" }, { id: 1, name: "Mujore" }, { id: 2, name: "Me ore" }]
  const contractExtension = [{ id: 0, name: "" }, { id: 1, name: "Mujore" }, { id: 2, name: "Vjetore" }]
  let { id } = useParams();
  const brutoNeto = [{ id: 0, name: "" }, { id: 1, name: "Bruto" }, { id: 2, name: "Neto" }]

  useEffect(() => {

    apiService()
      .get('worktype')
      .then((response) => {
        if (response.success) {
          setWorkTypes(response.data);
          //console.log(response.data);
        } else {
          alert('Error:' + response.errorMessage);
        }
      });

    apiService()
      .get('department')
      .then((response) => {
        if (response.success) {
          setDepartments(response.data);
          //console.log(response.data);
        } else {
          alert('Error:' + response.errorMessage);
        }
      });
    apiService()
      .get('branch')
      .then((response) => {
        if (response.success) {
          setBranch(response.data);
          //console.log(response.data);
        } else {
          alert('Error:' + response.errorMessage);
        }
      });

    setValue("WithTax", true)
    setValue("EmployeeTax", 5);
    setValue("EmployerTax", 5);
    getTemplates();
  }, []);


  const onSubmit = (data) => {
    data.WorkerId = id;
    data.ContractType = data.ContractType.id;
    data.WorkType = data.WorkType.id;
    data.SalaryType = data.SalaryType.id;
    data.Department = data.Department.id;
    data.BranchId = data.BranchId.id;
    data.BrutoNeto = data.BrutoNeto.id;
    data.Template = data.Template.id
    if (data.TermsOfContract === undefined) data.TermsOfContract = "";
    data.createdBy = "";
    console.log(data, id);
    apiService()
      .post('workerContract', data)
      .then((response) => {
        console.log(response)
        if (response.success) {
          setToast({
            open: true,
            message: 'U ruajten me sukses!',
            variant: 'success',
          });
          window.location.href = `#/workerlist/editworkercontract/${response.data.id}`
        } else {
          setToast({
            open: true,
            message: 'Ka ndodhur nje gabim!',
            variant: 'error',
          });
        }
      });
  };

  const toLowerKeys = (obj) => {
    return Object.keys(obj).reduce((accumulator, key) => {
      key = accumulator[key.charAt(0).toLowerCase() + key.slice(1, -1) + key.slice(-1).toLocaleLowerCase()] = obj[key];
      return accumulator;
    }, {});
  }

  const getTemplates = () => {
    apiService().get('contractsTemplates')
      .then(response => {
        if (response.success) {
          let arr = []
          let data = response.data
          data?.forEach(d => {
            //let obj = new ModelPurchaseDetails(d)
            arr.push(toLowerKeys(d))
          })
          setTemplates(arr)
        }
      })
  }

  const setTaxes = (isTrue) => {
    setValue('WithTax', isTrue);
    if (!isTrue) {
      setValue('EmployeeTax', 0);
      setValue('EmployerTax', 0);
    }
    else {
      !watch('EmployeeTax') ? setValue('EmployeeTax', 5) : setValue('EmployeeTax', watch('EmployeeTax'));
      !watch('EmployerTax') ? setValue('EmployerTax', 5) : setValue('EmployerTax', watch('EmployerTax'));
    }
  }

  return (
    <div className="">
      <Fragment>
        <Toast {...toast} />
        <TopActions
          newHref="/workerlist/addworker"
          save={handleSubmit(onSubmit)}
        />

        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Contract Details
            </Typography>
            <form>
              <Grid container spacing={3}>

                <Grid item xs={12} sm={3} lg={3}>
                  <InputController
                    placeholder="Data e fillimit"
                    error={errors.StartDate}
                    control={control}
                    type="date"
                    register={{ ...register('StartDate') }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={3}>
                  <InputController
                    placeholder="Data e mbarimit"
                    error={errors.EndDate}
                    control={control}
                    type="date"
                    register={{ ...register('EndDate') }}
                  />
                </Grid>

                <Grid item xs={12} sm={3} lg={3}>
                  <SelectController
                    placeholder="Lloji i punes"
                    error={errors.WorkType}
                    control={control}
                    options={workTypes}
                    name="WorkType"
                    register={{ ...register('WorkType') }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={3}>
                  <SelectController
                    placeholder="Filiali"
                    error={errors.BranchId}
                    control={control}
                    options={branch}
                    name="BranchId"
                    register={{ ...register('BranchId') }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={3}>
                  <SelectController
                    placeholder="Departamenti"
                    error={errors.Department}
                    control={control}
                    options={departments}
                    name="Department"
                    register={{ ...register('Department') }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={3}>
                  <SelectController
                    placeholder="Tipi i pages"
                    error={errors.SalaryType}
                    control={control}
                    options={salaryTypes}
                    name="SalaryType"
                    register={{ ...register('SalaryType') }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={3}>
                  <InputController
                    placeholder="Paga bazë"
                    error={errors.BaseSalary}
                    control={control}
                    symbol="€"
                    register={{ ...register('BaseSalary') }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={3}>
                  <SelectController
                    placeholder="Bruto/Neto"
                    error={errors.BrutoNeto}
                    control={control}
                    options={brutoNeto}
                    name="BrutoNeto"
                    register={{ ...register('BrutoNeto') }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={3}>
                  <InputController
                    placeholder="Paga per orë"
                    error={errors.HourSalary}
                    control={control}
                    symbol="€"
                    register={{ ...register('HourSalary') }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={3}>
                  <InputController
                    placeholder="Paga per orë ditë vikendi"
                    error={errors.HourSalaryWeekend}
                    control={control}
                    symbol="€"
                    register={{ ...register('HourSalaryWeekend') }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={3}>
                  <InputController
                    placeholder="Paga per orë ditë feste"
                    error={errors.HourSalaryHoliday}
                    control={control}
                    symbol="€"
                    register={{ ...register('HourSalaryHoliday') }}
                  />
                </Grid>
                <Grid item xs={12} sm={1} lg={1}>
                  <FormControlLabel
                    control={<Switch
                      error={errors.WithTax}
                      control={control}
                      name="WithTax"
                      register={{ ...register('WithTax') }}
                      onChange={(e) => setTaxes(e.target.checked)}
                      checked={watch("WithTax")}
                      defaultChecked={true}
                    />}
                    label="Kontributi"
                  />
                </Grid>
                {watch('WithTax') ?
                  <>
                    <Grid item xs={12} sm={2} lg={2}>
                      <InputController
                        placeholder="Kontributi i punëtorit"
                        error={errors.EmployeeTax}
                        control={control}
                        symbol="%"
                        value={watch('EmployeeTax') || 5}
                        register={{ ...register('EmployeeTax') }}
                        type="number"
                      />
                    </Grid>
                    <Grid item xs={12} sm={3} lg={3}>
                      <InputController
                        placeholder="Kontributi i punëdhënësit"
                        error={errors.EmployerTax}
                        control={control}
                        symbol="%"
                        value={watch('EmployerTax') || 5}
                        register={{ ...register('EmployerTax') }}
                        type="number"
                      />
                    </Grid>
                  </>
                  : ''}
                <Grid item xs={12} sm={3} lg={3}>
                  <SelectController
                    placeholder="Vazhdimi i kontratës"
                    error={errors.ContractExtension}
                    control={control}
                    options={contractExtension}
                    name="ContractType"
                    value=""
                    register={{ ...register('ContractType') }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={3}>
                  <SelectController
                    placeholder="Shablloni i kontratës"
                    error={errors.Template}
                    control={control}
                    options={templates}
                    name="Template"
                    value=""
                    register={{ ...register('Template') }}
                  />
                </Grid>

              </Grid>
              <Grid item spacing={4} style={{ marginTop: 20 }}>
                <TextareaAutosize
                  className='custom-textarea'
                  placeholder="Kushtet e kontratës"
                  error={errors.TermsOfContract}
                  control={control}
                  type="textarea"
                  register={{ ...register('TermsOfContract') }}
                  // cols="100"
                  style={{ width: '100%' }}
                  minRows={5}
                  name="TermsOfContract"
                  defaultValue=""
                  onChange={(e) => setValue('TermsOfContract', e.target.value)}
                />
              </Grid>
            </form>
          </CardContent>
        </Card>
      </Fragment>
    </div>
  );
}
